import { configureStore } from '@reduxjs/toolkit';

import messageModalReducer from './MessageModalSlice';
import webSettingsReducer from './WebSettingsSlice';
import ChatBotReducer from './ChatBotSlice';

const store = configureStore({
  reducer: {
    messageModal: messageModalReducer,
    webSettings: webSettingsReducer,
    chatBot: ChatBotReducer
  }
});

export default store;

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
